import { render, staticRenderFns } from "./userHeaderFix.vue?vue&type=template&id=a6506a10&scoped=true&"
import script from "./userHeaderFix.vue?vue&type=script&lang=js&"
export * from "./userHeaderFix.vue?vue&type=script&lang=js&"
import style0 from "./userHeaderFix.vue?vue&type=style&index=0&id=a6506a10&scoped=true&lang=scss&"
import style1 from "./userHeaderFix.vue?vue&type=style&index=1&id=a6506a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6506a10",
  null
  
)

export default component.exports